import { HStack, VStack } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { ClientsWhereColumn } from "@src/__generated__/urql-graphql";
import { DataTable } from "@src/components/ui-kit";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { FiltersPanelRoot } from "@src/utils/components/filters/components/filters-panel";
import { FiltersPanelFilters } from "@src/utils/components/filters/components/filters-panel-filters";
import { FiltersPanelSearch } from "@src/utils/components/filters/components/filters-panel-search";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import { AddBtn } from "../../brands/listing/common";
import { useStore } from "./store";
import { TableClients } from "./TableClients";

export const CardListClients = observer(function CardListClients() {
  const store = useStore();

  return (
    <DataTable>
      <DataTable.Filter>
        <FiltersPanelRoot<ClientsWhereColumn> filters={store.where}>
          <VStack align="start" spacing="3">
            <HStack w="full" spacing="2">
              <FiltersPanelSearch
                searchPlaceholder={t`Search by brand, client, contact person`}
                w="full"
                inputWidth="full"
                defaultValue={store.searchTerm}
                onSearch={(val) => {
                  store.searchTerm = val;
                  store.pagination.resetPage();
                }}
              />
              <FiltersPanelFilters />
              {can("client_create", "brand_create") && <AddBtn />}
            </HStack>
          </VStack>
        </FiltersPanelRoot>
      </DataTable.Filter>
      <TableClients />
      <Pagination store={store.pagination} />
    </DataTable>
  );
});
